<script setup>
import { getRequest, postRequest, putRequest } from "@/utils/request.js";
import { message } from "ant-design-vue";
import { reactive, ref, unref } from "vue";

const emit = defineEmits(["ok"]);
const title = ref("");
const open = ref(false);
const confirmLoading = ref(false);

let formModel = ref({});
const formRef = ref();
const roleOptions = ref([]);

const rules = reactive({
  username: [
    {
      required: true,
      message: "请输入用户名",
      trigger: "blur",
    },
  ],
  realName: [
    {
      required: true,
      message: "请输入姓名",
      trigger: "blur",
    },
  ],
  phone: [
    {
      required: true,
      message: "请输入电话",
      trigger: "blur",
    },
    {
      pattern: /^1[345789]\d{9}$/,
      message: "请输入正确的手机号",
      trigger: "blur",
    },
  ],
  password: [
    {
      required: true,
      message: "请输入密码",
      trigger: ["change", "blur"],
    },
    {
      min: 6,
      message: "密码长度至少6位",
      trigger: ["change", "blur"],
    },
    {
      max: 18,
      message: "密码长度最多18位",
      trigger: ["change", "blur"],
    },
    {
      pattern: /^(?=.*[A-Z])(?=.*[a-z])(?=.*[^\w\s]).{6,}$/,
      message:
        "密码强度不足，密码应满足大写字母+小写字母+特殊字符!@#$%^&*()\\-_=+{}[\\]|;:'\",<>.?/",
      trigger: ["change", "blur"],
    },
  ],
});

const handleAdd = () => {
  handleEdit({});
};

const handleEdit = (record) => {
  formModel.value = Object.assign(
    {},
    {
      ...record,
    },
    {
      phone: null,
      oldPhone: record.phone,
    },
  );
  open.value = true;
  if (formModel.value.id) {
    if (formModel.value.oldPhone) {
      rules.phone[0].required = false;
    }
    rules.password[0].required = false;
  }
  loadRoleData();
};

const loadRoleData = () => {
  getRequest("/role/options").then((res) => {
    if (res.success) {
      roleOptions.value = res.data;
    }
  });
};

const handleClose = () => {
  open.value = false;
  formRef.value.resetFields();
  rules.password[0].required = true;
  rules.phone[0].required = true;
};

const handleConfirm = async () => {
  formRef.value.validate().then(async () => {
    const unrefFormModel = unref(formModel);
    let request;
    if (unrefFormModel.id) {
      request = putRequest;
    } else {
      request = postRequest;
    }
    request("/user", unrefFormModel).then((response) => {
      if (response.success) {
        message.success("保存成功");
        emit("ok");
        handleClose();
      } else {
        message.error("保存失败。" + response.message);
      }
    });
  });
};

defineExpose({
  handleAdd,
  handleEdit,
  handleClose,
  title,
});
</script>

<template>
  <a-modal
    width="800px"
    :open="open"
    :title="title"
    :confirm-loading="confirmLoading"
    @cancel="handleClose"
    @ok="handleConfirm"
  >
    <a-form
      ref="formRef"
      :labelCol="{ span: 3 }"
      :wrapperCol="{ span: 24 }"
      :model="formModel"
      :rules="rules"
    >
      <a-form-item label="用户名" name="username">
        <a-input
          v-model:value="formModel.username"
          autocomplete="off"
          placeholder="请输入用户名"
        />
      </a-form-item>
      <a-form-item label="姓名" name="realName">
        <a-input v-model:value="formModel.realName" placeholder="请输入姓名" />
      </a-form-item>
      <a-form-item label="电话" name="phone">
        <a-input
          v-model:value="formModel.phone"
          :placeholder="
            formModel.oldPhone ? `电话：${formModel.oldPhone}` : '请输入电话'
          "
        />
      </a-form-item>
      <a-form-item v-if="!formModel.id" label="密码" name="password">
        <a-input-password
          v-model:value="formModel.password"
          autocomplete="off"
          placeholder="请输入密码"
        />
      </a-form-item>
      <a-form-item label="角色" name="roleIds">
        <a-select
          v-model:value="formModel.roleIds"
          :options="roleOptions"
          mode="multiple"
          placeholder="请输入角色，支持多选"
        ></a-select>
      </a-form-item>
    </a-form>
  </a-modal>
</template>

<style scoped lang="scss"></style>
